var map = {
	"./404.svg": "a14a",
	"./api.svg": "7476",
	"./bank-account.svg": "026c",
	"./bank.svg": "8315",
	"./binary-code.svg": "5bb0",
	"./blacklist.svg": "4407",
	"./closed.svg": "11f8",
	"./collected.svg": "fc76",
	"./company.svg": "9ef7",
	"./compliance.svg": "0578",
	"./connect.svg": "9580",
	"./contract-agreement.svg": "9e59",
	"./customer.svg": "b17f",
	"./dashboard.svg": "f782",
	"./debt.svg": "1257",
	"./email.svg": "cbb7",
	"./eur.svg": "ba90",
	"./firewall.svg": "3448",
	"./gbp.svg": "3bae",
	"./introducer.svg": "993b",
	"./missing.svg": "d7be",
	"./money.svg": "3046",
	"./network.svg": "0411",
	"./payment.svg": "ea4f",
	"./peoples.svg": "2f11",
	"./phone.svg": "dd82",
	"./profile-setting.svg": "186a4",
	"./profile.svg": "f93a",
	"./project.svg": "69e4",
	"./report.svg": "9e5c",
	"./restrict.svg": "673f",
	"./risk.svg": "c5bd",
	"./rule.svg": "38fb",
	"./savings.svg": "e33b",
	"./team.svg": "64c9",
	"./template.svg": "dcbb",
	"./thb.svg": "3227",
	"./trade.svg": "07d5",
	"./trading.svg": "35e1",
	"./usd.svg": "4beb",
	"./user.svg": "b3b5",
	"./webhooks.svg": "9179",
	"./www.svg": "a824"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";